import { computed } from 'vue';
import currencyList, {
  currency,
  currencyOrderSizeEnum,
  orderIndex,
} from '@/components/helpers/currency-list';
import { useI18n } from '@/composables';
import { useStore } from '@/store';
type CurrencyListItem = currency & {
  sign?: string;
  index?: number;
  size?: number;
};

export const useCurrencyList = () => {
  const { t } = useI18n();
  const store = useStore();
  const currencies = currencyList;
  const fillCurrencies = (item: currency): CurrencyListItem => ({
    ...item,
    name: t(item.name),
    sign: currencies[item.code],
    index: orderIndex[item.code].index,
    size: orderIndex[item.code].size,
  });

  const sortCurrencies = (items: CurrencyListItem[]) =>
    [...items].sort((itemA, itemB) => {
      const valueA = itemA.index ?? 0;
      const valueB = itemB.index ?? 0;
      if (valueA > valueB) return 1;
      if (valueA < valueB) return -1;
      return 0;
    });

  const currencyListFromStore = computed(() => store.currencyList || []);
  const currencyListOrderedPreferred = computed(() => {
    const preferredCurrency = store.user.preferredCurrency;
    const result = currencyListFromStore.value
      .filter(
        (item: currency) => preferredCurrency.includes(item.code) && !!currencies[item.code],
      )
      .map(fillCurrencies);

    return sortCurrencies(result);
  });

  const currencyListOrdered = computed(() => {
    const result = currencyListFromStore.value
      .filter((item: currency) => !!currencies[item.code])
      .map(fillCurrencies);

    return sortCurrencies(result);
  });

  const currenciesLowerCase = computed(() => {
    const result: Record<string, string> = {};
    Object.keys(currencies).forEach((key) => {
      result[key.toLowerCase()] = currencies[key];
    });
    return result;
  });

  return {
    currencies,
    currencyOrderSizeEnum,
    currencyListOrderedPreferred,
    currencyListOrdered,
    currenciesLowerCase,
    fillCurrencies,
    sortCurrencies,
  };
};
